import React from "react";

const ClassRepresentativeInfoCard = () => {
  return (
    <div
      className="h-full flex-col align-left justify-start g-2 p-2 back-white radius-10"
      style={{ width: "20rem", borderTop: "8px solid var(--tableColor)" }}
    >
      <h3 className="weight-500 t-18 poppins-medium color-textColor">
        Class representatives
      </h3>
      <p className="t-13 poppins " style={{ color: "var(--tableColor)" }}>
        <span className="t-13 color-textColor mr-05">Working field:</span>
        Represent each classes for their academic requirement
      </p>
    </div>
  );
};

export default ClassRepresentativeInfoCard;
